export const MANUAL_CONTACT_NAME_MAX_LENGTH = 100;

export const MANUAL_CONTACT_EMAIL_MAX_LENGTH = 100;

export const MANUAL_CONTACT_PHONE_MAX_LENGTH = 50;

export const REACHABILITY_ERROR_MESSAGE = 'Email or a phone is required';

export const ManualContactFormButtonText = {
  CANCEL: 'Cancel',
  ADD: 'Add',
  SAVE: 'Save',
};
